import React, {useEffect, useState} from 'react';
import ListBox from "../../../../ui/ListBox/ListBox";
import {IUserAccessSettings} from "../../../../../app/interfaces/user/IUserAccessSettings";
import {IListTransportLineItem} from "../../../../../app/interfaces/shared/IListTransportLineItem";
import {useAppDispatch, useAppSelector} from "../../../../../app/store";
import {useDataHelperApi} from "../../../../../app/api/dataHelper";
import {ResponseResultCode} from "../../../../../app/enums/ResponseResultCode";
import {isAxiosError} from "axios";
import {toast} from "react-toastify";
import TagContainer from "../../../../ui/Tag/TagContainer/TagContainer";
import {TagItem, TagItemBackgroundColor} from "../../../../ui/Tag/Tag";
import {selectAccessSettingsTransportLinesDestination} from "../../../../../features/filter/filterSliceSelectors";
import {setAccessSettings, setAccessSettingsData} from "../../../../../features/filter/filterSlice";

type AccessSettingsTransportLineDestinationFilterProps = {
    disabled: boolean;
    settings: IUserAccessSettings;
    isExpanded: boolean;
}

const AccessSettingsTransportLineDestinationFilter: React.FC<AccessSettingsTransportLineDestinationFilterProps> = ({
                                                                                                                       disabled,
                                                                                                                       settings,
                                                                                                                       isExpanded
                                                                                                                   }) => {
    const [data, setData] = useState<Array<IListTransportLineItem>>([]);
    const tld = useAppSelector(selectAccessSettingsTransportLinesDestination);
    const dispatch = useAppDispatch();

    const {
        getAccessFilterTransportLines: {
            query,
            isLoading
        }
    } = useDataHelperApi();

    useEffect(() => {
        if (tld.length > 0) {
            return;
        }

        (async () => {
            try {
                const response = await query('destination');

                if (response?.data?.resultCode === ResponseResultCode.Ok && response?.data.data) {
                    dispatch(setAccessSettingsData({
                        entity: 'TransportLinesDestination',
                        data: {
                            transportLinesDestination: response.data.data
                        } as any
                    }));
                }
            } catch (e) {
                if (isAxiosError(e)) {
                    toast.error('Unable to load transport lines list: ' + e.message);
                }
            }
        })();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (data.length > 0 || tld.length <= 0) {
            return;
        }

        setData([...tld]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tld]);

    const onFilter = (value: string | null) => {
        if (!value || value === '') {
            setData([...tld]);
        } else {
            setData([
                ...tld.filter(item => {
                    return item.destination.toLowerCase().includes(value.toLowerCase())
                })
            ]);
        }
    }

    return (
        <div style={{margin: '10px 0'}}>
            {isExpanded &&
                <div style={{marginBottom: '5px'}}>
                    <TagContainer id={'access-settings-tld-filter-tags'}
                                  width={'100%'}
                                  height={'100px'}
                                  items={settings.transportLinesDestination.filter(e => {
                                      return tld.find(ex => ex.destination === e) !== undefined;
                                  }).map((item) => {
                                      let existItem = tld.find(ex => ex.destination === item) as IListTransportLineItem;

                                      return {
                                          id: `tld-tag-${existItem.destination}`,
                                          text: existItem.destination,
                                          data: existItem,
                                          showClearIcon: true,
                                          backgroundColor: TagItemBackgroundColor.LightGray,
                                          rounded: true
                                      } as TagItem;
                                  })}
                                  onClear={({data}) => {
                                      if (data !== undefined && data !== null) {
                                          let item = data as IListTransportLineItem;

                                          dispatch(setAccessSettings({
                                              ...settings,
                                              transportLinesDestination: [
                                                  ...settings.transportLinesDestination.filter(e => e !== item.destination)
                                              ]
                                          }));
                                      }
                                  }}/>
                </div>
            }
            <ListBox id={'access-settings-tld-filter'}
                     selected={settings.transportLinesDestination.map(item => {
                         return {
                             text: item,
                             value: item
                         }
                     })}
                     disabled={disabled}
                     data={data.map(item => {
                         return {
                             text: item.destination,
                             value: item.destination
                         }
                     })}
                     isLoading={isLoading}
                     onFilter={onFilter}
                     height={250}
                     selection={'Multiple'}
                     onSelectionChange={(items) => {
                         dispatch(setAccessSettings({
                             ...settings,
                             transportLinesDestination: [...items.map(item => item.value)]
                         }));
                     }}/>
        </div>
    );
};

export default AccessSettingsTransportLineDestinationFilter;